import { Component, inject } from '@angular/core';
import { TranslocoDirective, TranslocoPipe } from '@jsverse/transloco';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from 'htx-ui-library';
import { AsyncPipe } from '@angular/common';
import { AuthService } from '../../../services/auth/auth.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  imports: [
    TranslocoDirective,
    ButtonComponent,
    TranslocoPipe,
    ReactiveFormsModule,
    RouterLink,
    AsyncPipe
  ],
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  private authService = inject(AuthService);

  isLoggedIn$ = this.authService.isLoggedIn$;

  /**
   * t(home.registerButton)
   */
  registerButtonKey = 'home.registerButton';

  /**
   * t(home.demoButton)
   */
  demoButtonKey = 'home.demoButton';

  goToRegister() {
    void this.router.navigate(['registration'], { relativeTo: this.activatedRoute });
  }

  watchDemo() {
    window.alert('Not implemented yet');
  }
}
